import { render } from "./Manifest.vue?vue&type=template&id=08e7b32a&scoped=true"
import script from "./Manifest.vue?vue&type=script&lang=js"
export * from "./Manifest.vue?vue&type=script&lang=js"

import "./Manifest.vue?vue&type=style&index=0&id=08e7b32a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e7b32a"]])

export default __exports__